import { UserManager } from "oidc-client";
import config from "./config";

export const createUserManager = () => new UserManager({ ...config, monitorSession: false });

export const createUserManagerWithRedirect = (redirect_uri: string) =>
    new UserManager({ ...config, monitorSession: false, redirect_uri: redirect_uri });
